import { Download } from 'lucide-react';

function ManualDownloadLink({ href, fileName, label = '매뉴얼 다운로드', tone = 'blue' }) {
    const color = tone === 'teal' ? '#0f766e' : '#2563eb';
    const bg = tone === 'teal' ? '#ecfdf5' : '#eff6ff';
    const url = `${href}`;

    return (
        <a
            href={url}
            download={fileName}
            style={{
                height: '30px',
                border: '1px solid ' + color,
                borderRadius: '5px',
                backgroundColor: bg,
                color,
                padding: '0 9px',
                fontSize: '12px',
                fontWeight: 800,
                cursor: 'pointer',
                display: 'inline-flex',
                alignItems: 'center',
                gap: '5px',
                textDecoration: 'none',
                flexShrink: 0,
            }}
        >
            <Download size={14} />
            {label}
        </a>
    );
}

export default ManualDownloadLink;
